import { LoadState } from "../../constants/enums";
import {
  IRestrictedModule,
  ISubscriptionPlan,
  ISubscriptionPlanFeature,
  ISubscriptionPlanState,
  ISubscriptionPriorityList,
  IUserSubscription,
} from "./subscription.types";

export const defaultSubscriptionPlanFeature: ISubscriptionPlanFeature = {
  subscription_plan_feature_uuid: null,
  subscription_plan_uuid: null,
  module: "",
  use_count: 0,
  table_name: "",
  table_identifier_column: "",
  description: "",
  is_included: 0,
  feature_name: "",
  show_on_card: 0,
  endpoint_method: "",
  module_endpoint: "",
  count_reset_per_period: 0,
  count_reset_per_duration: null,
  module_master_uuid: null,
  priority: null,
  status: "ACTIVE",
};

export const defaultSubscriptionPlan: ISubscriptionPlan = {
  subscription_plan_uuid: null,
  plan_name: "",
  description: "",
  is_plan_addon: 0,
  is_internal_plan: false,
  is_free_plan: 0,
  is_trial: 0,
  period: 1,
  billing_cycle: "months",
  trial_period: -1,
  trial_cycle: null,
  price: [{
    strikeout_amount: 0,
    amount: 0,
    currency: "INR",
    base_amount: 0,
    gst: 0,
    gst_type: "PERCENTAGE",
    gst_amount: 0,
  }],
  tags: [],
  subscription_features: [],
  status: "ACTIVE",
};

export const initialUserSubscription: IUserSubscription = {
  user_subscription_uuid: null,
  subscription_plan_uuid: null,
  user_uuid: null,
  validity: null,
  start_at: null,
  expired_at: null,
  status: "ACTIVE",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
};

export const initialSubscriptionPriorityList: ISubscriptionPriorityList = {
  priority_list_uuid: "",
  priority_number: null,
  reference_column_name: "",
  reference_column_uuid: "",
  module_name: "SUBSCRIPTION_PLAN_FEATURE",
  status: "ACTIVE",
};

export const initialRestrictedModule: IRestrictedModule = {
  subscription_restricted_module_uuid: null,
  subscription_plan_uuid: null,
  module_name: null,
  read: null,
  write: null,
  view: null,
  write_count_limit: null,
  status: "ACTIVE",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
};

export const initialSubscriptionPlanState: ISubscriptionPlanState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  subscriptionPlan: {
    data: defaultSubscriptionPlan,
    loading: LoadState.NotLoaded,
    error: null,
  },
  userSubscriptionList: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  userSubscription: {
    data: initialUserSubscription,
    loading: LoadState.NotLoaded,
    error: null,
  },
  restrictedModule: {
    data: initialRestrictedModule,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
